import { mmUid } from 'mm-ts-utils';
// declare const window: any;
var _localBrowserId;
export var getBrowserId = function () {
    if (_localBrowserId === void 0) {
        // just to naively obfuscate a little bit from the outside, "browserId" might
        // seem too evil
        var KEY = 'bid';
        try {
            _localBrowserId = window.localStorage.getItem(KEY);
            if (!_localBrowserId) {
                _localBrowserId = mmUid();
                window.localStorage.setItem(KEY, _localBrowserId);
            }
        }
        catch (e) {
            _localBrowserId = null;
        }
    }
    return _localBrowserId;
};
